export enum FileType {
    Audio = 'Audio',
    Document = 'Document',
    Image = 'Image',
    Video = 'Video',
    Text = 'Text',
    Other = 'Other'
}
